import React from 'react';
import { useParams } from 'react-router-dom';
import GuestRoom from './GuestRoom';

export default function GuestLanding() {
    const { roomUrl } = useParams();
    const displayName = sessionStorage.getItem('guestDisplayName') || '';

    return <GuestRoom roomUrl={roomUrl} displayName={displayName} />;
}
